import * as C from '../Constants'

const GlobalDataRed = (state = {}, action) => {
   
    switch(action.type){
        case C.GET_GLOBALDATA:
            return{
                ...state,
                gettingGlobalData:true
            }
        case C.GET_GLOBALDATA_SUCCESS:
            return{
                ...state,
                gettingGlobalData:false,
                Global_Stat:action.Global_Stat
            }
            default:
                return state;
    }
}
export default GlobalDataRed
